export const classes = {
  wrapper: 'ConfirmationPage-wrapper',
  loaderWrapper: 'loader-wrapper',
  loaderMessage: 'loader-message',
  messageWrapper: 'message-wrapper',
  bigText: 'big-text',
  smallText: 'small-text',
  controlsWrapper: 'controls-wrapper',
}
